import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ByAuthorBlock from '@bibliocommons/base-by-author-block';
import FormatIndicator from '@bibliocommons/format-indicator';

export default function BibScreenReaderDescription({ bibBrief }) {
  const title = bibBrief.get('title');
  const authors = bibBrief.get('authors');
  const format = bibBrief.get('format');

  return (
    <div className="cp-bib-screen-reader-description">
      {title}
      {format ? <FormatIndicator format={format.toUpperCase()} /> : null}{' '}
      <ByAuthorBlock authors={authors} renderAsLink={false} />
    </div>
  );
}

BibScreenReaderDescription.propTypes = {
  bibBrief: ImmutablePropTypes.map
};
